export default __webpack_public_path__ + "static/media/block1.5dac2426.webp";